
import React from "react";
import fields from "../../json/Department.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import PropTypes from "prop-types";

const EditDepartmentForm = ({
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
}) => {
    const { formdata } = fields;
    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>Edit Department</HeadingOne>
        }>
            {formdata.map((field) => {
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update Department"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

EditDepartmentForm.propTypes = {
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default EditDepartmentForm;
